import React from 'react';
import { bonuses } from '../../mock/mock';
import { Gift, Sparkles } from 'lucide-react';
import { Camera, Gift as GiftP, Star, BookOpenText } from '@phosphor-icons/react';
import AppIcon from '../AppIcon';

const BONUS_ICONS = [[GiftP, 'rose'], [Camera, 'sky'], [Star, 'gold'], [BookOpenText, 'sage']];

export default function Bonuses() {
  return (
    <section className="py-24 lg:py-32 bg-[#FBF7F2]">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full tag-chip text-xs font-medium mb-4">
            <Gift className="w-3.5 h-3.5" />
            Exclusive bonuses
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl text-[#2A2A2A] leading-tight">
            Small extras. <span className="italic text-[#7B2C3B]">Big</span> difference.
          </h2>
          <p className="mt-4 text-[#4A4A4A]">Included with the Full Planner, on the house.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {bonuses.map((b, i) => (
            <div
              key={i}
              data-testid={`bonus-card-${i}`}
              className="group soft-card rounded-2xl p-7 hover:translate-y-[-3px] transition-transform duration-300 relative"
            >
              <AppIcon icon={BONUS_ICONS[i % 4][0]} tone={BONUS_ICONS[i % 4][1]} size="md" interactive reveal delay={i * 100} className="mb-4" />
              {b.badge && (
                <div className="absolute -top-3 left-7 px-3 py-1 rounded-full bg-[#7B2C3B] text-[#FBF7F2] text-xs font-medium inline-flex items-center gap-1.5">
                  <Sparkles className="w-3 h-3" />
                  {b.badge}
                </div>
              )}
              <h3 className="font-serif text-2xl text-[#2A2A2A] mb-2">{b.title}</h3>
              <p className="text-[#4A4A4A] leading-relaxed mb-5">{b.description}</p>
              <ul className="space-y-2">
                {b.points.map((p, j) => (
                  <li key={j} className="text-sm text-[#3A3A3A] flex items-start gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#B8896C] mt-2 flex-shrink-0" />
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
